import React from "react";
import { Image, Text, View } from "react-native";
import { STYLES } from "../assets/styles";
import { SCREEN_WIDTH } from "../common";
import cError from "./../assets/images/404.svg";
import sError from "./../assets/images/500.svg";
import nError from "./../assets/images/no_connection.jpg";
import CustomButton from "./CustomButton";

function Errors({ error, onPress = () => {} }) {
  const errors = {
    "client error": {
      image: cError,
      text: "Error, requesting for is not found",
    },
    "server error": {
      image: sError,
      text: "Ooops !, something went wrong in server. please try again after sometime.",
      tryAgain: true,
    },
    "network error": {
      image: nError,
      text: "Unable to connect with the server. please check your internet connection or try again.",
      tryAgain: true,
    },
  };
  return (
    <View
      style={{
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: STYLES.colors.white,
      }}
    >
      {errors[error] ? (
        <View
          style={{
            justifyContent: "center",
            alignItems: "center",
            padding: 20,
          }}
        >
          <Image
            source={errors[error].image}
            style={{ width: SCREEN_WIDTH * 0.8, height: SCREEN_WIDTH * 0.8 }}
          />
          <Text
            style={{
              width: SCREEN_WIDTH * 0.8,
              textAlign: "center",
              fontSize: STYLES.fontSizes.small,
              marginVertical: 5,
            }}
          >
            {errors[error].text}
          </Text>
          <CustomButton
            text="Try Again"
            btnStyle={{
              backgroundColor: STYLES.colors.purpel,
              paddingVertical: 0,
            }}
            textStyle={{ color: STYLES.colors.white }}
            onPress={onPress}
          />
        </View>
      ) : null}
    </View>
  );
}

export default Errors;
